import styled from 'styled-components';
import { Progress } from 'antd';

const AntdProgressBar = styled(Progress)`
  .ant-progress-inner {
    background-color: #D5D5D5;
  }`;

export default AntdProgressBar;
